import { render, staticRenderFns } from "./ManageHolidays.vue?vue&type=template&id=75baee18"
import script from "./ManageHolidays.vue?vue&type=script&lang=ts"
export * from "./ManageHolidays.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports